export default __webpack_public_path__ + "static/media/about1.f51c932f.svg";